module.exports = __webpack_public_path__ + "img/voting-bars.4dd64e3d.png";